let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5zXQz")).then(() => parcelRequire('7Osqc'));